module.exports = __webpack_public_path__ + "static/video_city-11fccaea8b192b8b4d1ff4519d80769b.jpg";